import { getDefaultTextureData } from '../../components/Configurator/utils';
import { getDefaultTextureImageUrl } from '../../components/admin/curator/stylesSection/PropertiesTab/useGetDefaultObjectMaps';
import {
  CHANGED_MAP_IDS__TEXTURE_MAP,
  CHANGED_MAP_PATHS__TEXTURE_MAP,
  TEXTURE_MAP__TEXTURE_NAME_KEY,
} from '../../config/constant/unityConstants';
import { getMaterial, getTexture } from '../idb';

export const addDefaultTexturesToObject = async (objectData, validateTextureName) => {
  const updatedObject = {
    ...objectData,
    changedMapsPath: { ...objectData?.changedMapsPath },
  };

  const promiseList = Object.entries(CHANGED_MAP_IDS__TEXTURE_MAP).map(async ([mapType, idKey]) => {
    const isNumber = /^\d+$/.test(updatedObject.changedMapsPath[idKey]);
    const textureId = isNumber
      ? parseInt(updatedObject.changedMapsPath[idKey])
      : updatedObject.changedMapsPath[idKey];
    const pathKey = CHANGED_MAP_PATHS__TEXTURE_MAP[mapType];

    if (textureId) {
      let texture = {};
      if (isNumber) {
        texture = await getTexture(textureId);
      } else {
        const file = await getDefaultTextureData({ name: textureId });
        texture = {
          file,
        };
      }
      const file = texture?.file;
      updatedObject.changedMapsPath[pathKey] = file;
      return;
    }

    // check if object has default texture
    const textureNameKey = TEXTURE_MAP__TEXTURE_NAME_KEY[mapType];
    const textureName = objectData?.[textureNameKey];
    const imageUrl = await getDefaultTextureImageUrl({
      textureName,
      materialId: objectData?.loadedMaterialId,
    });

    if (validateTextureName && !textureName) {
      return;
    }

    if (imageUrl) {
      updatedObject.changedMapsPath[pathKey] = imageUrl;
    }
  });

  if (updatedObject?.loadedMaterialId && updatedObject?.loadedMaterialId !== 'Not Changed') {
    const updateMaterialPath = async () => {
      const materialId = parseInt(updatedObject?.loadedMaterialId);
      const material = await getMaterial(materialId);
      updatedObject.loadedMaterialPath = material?.file;
    };

    promiseList.push(updateMaterialPath());
  }

  await Promise.all(promiseList);

  return updatedObject;
};
